// extracted by mini-css-extract-plugin
export var createAcct = "header-module--createAcct--57bc4";
export var customNav = "header-module--customNav--9be09";
export var dropMenu = "header-module--dropMenu--28350";
export var dropdownBigItem = "header-module--dropdownBigItem--ad462";
export var dropdownItem = "header-module--dropdownItem--342f5";
export var dropdownMenuContent = "header-module--dropdownMenuContent--7d406";
export var dropdownSubItem = "header-module--dropdownSubItem--6eac2";
export var homePageNav = "header-module--homePageNav--8e6d2";
export var login = "header-module--login--b1813";
export var navLink = "header-module--navLink--a4c9c";